import React, { useEffect, useState } from "react";
import "./index.less";
import { Spin, Tree } from "antd";
import type { TreeDataNode, TreeProps } from "antd";
import LightingInvokeButton from "../LightningButton/LightningInvokeButton";
import LightingInvokeStrike from "../LightningButton/LightningInvokeStrike";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@/redux/reducer/store";
import { IGetCountriesTreeResModel } from "@/util/http/Lightning/responseType";
import {LightningPlusIcon,CloseIcon} from "@/resource/IconComponents";
import { updateCommonWarnMessage,
    updateFinalRequestBoundaryState,
    updateIsLoadingForGetBoundary,
    updateAutoExpandParent,
    updateSelectedKeys,
    updateExpandedKeys,
    updateCheckedKeys,
    updateSelectedCountry,
    updateNeedClearRegion,
    updateFinalRequestBoundaryCode}
    from "@/redux/actions/lightningAction";
import localforage from "localforage";
import { getBoundaries } from "@/util/http/Lightning";
import closeIcon from "@/resource/images/png/lightning/close.png";
import { LightningTabsEnum } from "@/util/cosntants";

interface IStateModel{
    stateName?: string;
    cityList?: string[];
}
interface ICodeModel{
    stateName: string;
    stateCode: string;
    cityList?: {
        cityName: string;
        cityCode: string;
    }[];
}

interface IDisplayModel{
    name: string;
    code: string;
}


const LightningRegion = () => {

    const countriesTreeData = useSelector((state: RootState) => state.lightningReducer.countriesTreeData);
    const finalRequestBoundaryState = useSelector((state: RootState) => state.lightningReducer.finalRequestBoundaryState);
    const finalRequestBoundaryCode = useSelector((state: RootState) => state.lightningReducer.finalRequestBoundaryCode);
    const isLoadingForGetBoundary = useSelector((state: RootState) => state.lightningReducer.isLoadingForGetBoundary);
    const selectedFavouritesInformation = useSelector((state: RootState) => state.lightningReducer?.selectedFavouritesInfo);
    const needClearRegion = useSelector((state: RootState) => state.lightningReducer?.needClearRegion);

    const dispatch = useDispatch();

    const [expandedKeys, setExpandedKeys] = useState<React.Key[]>([]);
    const [checkedKeys, setCheckedKeys] = useState<React.Key[]>([]);
    const [selectedKeys, setSelectedKeys] = useState<React.Key[]>([]);
    const [autoExpandParent, setAutoExpandParent] = useState<boolean>(true);

    const [finalTreeData,setFinalTreeData] = useState<TreeDataNode[]>([]);

    // const [finalRequestBoundaryState, setFinalRequestBoundaryState] = useState<string[]>([]);
    // const [displaySelectedRegionName, setDisplaySelectedRegionName] = useState<string[]>([]);
    const [displaySelectedRegionName, setDisplaySelectedRegionName] = useState<IDisplayModel[]>([]);


    useEffect(() => {
        if(checkedKeys?.length >= 1){
            const tmpRequestBoundaryState: string[] = [];
            const tmpCheckedStates:IStateModel[] = [];
            const isAllUsa = checkedKeys?.find(item => item === "United States") !== undefined;
            if(isAllUsa){
                dispatch(updateFinalRequestBoundaryState(["United States"]));
                return;
            }
            checkedKeys.forEach((item) => {
                const splitItem = item.toString().split("#");
                if (splitItem.length === 2) { // 确保是国家#州/省格式
                    const tmpValue = tmpCheckedStates.find(state => state.stateName === splitItem[1]);
                    if(!tmpValue) { // 如果不存在这个州/省，则添加
                        tmpCheckedStates.push({
                            stateName: splitItem[1],
                            cityList: []
                        });}
                } else if (splitItem.length === 3) { // 确保是国家#州/省#城市格式
                    const existingState = tmpCheckedStates.find(state => state.stateName === splitItem[1]);
                    if (existingState) {
                        existingState.cityList?.push(splitItem[2]); // 添加城市到已存在的州/省
                    } else {
                        tmpCheckedStates.push({
                            stateName: splitItem[1],
                            cityList: [splitItem[2]]
                        });
                    }
                }
            });

            // check whether selected all city for state
            tmpCheckedStates.forEach((state) => {
                const stateCities = countriesTreeData?.filter(item => item.state === state.stateName).map(item => item.city);
                if (stateCities && stateCities.length > 0) {
                    // 如果州/省下有城市，则检查是否选中所有城市
                    const allCitiesSelected = state.cityList?.length === stateCities.length && state.cityList?.every(city => stateCities.includes(city));
                    if (allCitiesSelected) {
                        // 如果选中所有城市，则将州/省添加到最终请求边界状态中
                        tmpRequestBoundaryState.push(state.stateName);
                    } else {
                        // 否则，添加州/省和选中的城市
                        state?.cityList?.forEach(city => {
                            tmpRequestBoundaryState.push(city);
                        });
                    }
                } else {
                    // 如果没有城市，则只添加州/省
                    // setFinalRequestBoundaryState(prev => [...prev, `${state.stateName}`]);
                    tmpRequestBoundaryState.push(state.stateName);
                }
            });

            // setFinalRequestBoundaryState(tmpRequestBoundaryState);
            dispatch(updateFinalRequestBoundaryState(tmpRequestBoundaryState));
        }
        else{
            dispatch(updateFinalRequestBoundaryState([]));
        }
    },[checkedKeys]);

    useEffect(() => {
        if(checkedKeys?.length >= 1){
            const tmpRequestBoundaryCode: string[] = [];
            const tmpCheckedStates:ICodeModel[] = [];
            const isAllUsa = checkedKeys?.find(item => item === "United States") !== undefined;
            if(isAllUsa){
                dispatch(updateFinalRequestBoundaryCode(["USA"]));
                return;
            }
            console.log("lanxue aaa");
            checkedKeys.forEach((item) => {
                const splitItem = item.toString().split("#");
                if (splitItem.length === 2) { // 确保是国家#州/省格式
                    const tmpValue = tmpCheckedStates.find(state => state.stateName === splitItem[1]);
                    const tmpState = countriesTreeData?.find(item => item.state === splitItem[1]);
                    if(!tmpValue) { // 如果不存在这个州/省，则添加
                        tmpCheckedStates.push({
                            stateName: splitItem[1],
                            stateCode: tmpState?.stateCode || "",
                            cityList: []
                        });}
                } else if (splitItem.length === 3) { // 确保是国家#州/省#城市格式
                    const existingState = tmpCheckedStates.find(state => state.stateName === splitItem[1]);
                    const tmpCity = countriesTreeData?.find(item => item.state === splitItem[1] && item.city === splitItem[2]);
                    if (existingState) {
                        existingState.cityList?.push({
                            cityName: splitItem[2],
                            cityCode: tmpCity?.cityCode || ""
                        }); // 添加城市到已存在的州/省
                    } else {
                        tmpCheckedStates.push({
                            stateName: splitItem[1],
                            stateCode: tmpCity?.stateCode || "",
                            cityList: [{
                                cityName: splitItem[2],
                                cityCode: tmpCity?.cityCode || ""
                            }]
                        });
                    }
                }
            });

            // check whether selected all city for state
            tmpCheckedStates.forEach((state) => {
                const stateCities = countriesTreeData?.filter(item => item.state === state.stateName).map(item => item.city);
                if (stateCities && stateCities.length > 0) {
                    // 如果州/省下有城市，则检查是否选中所有城市
                    const allCitiesSelected = state.cityList?.length === stateCities.length && state.cityList?.every(city => stateCities.includes(city?.cityName));
                    if (allCitiesSelected) {
                        // 如果选中所有城市，则将州/省添加到最终请求边界状态中
                        tmpRequestBoundaryCode.push(state.stateCode);
                    } else {
                        // 否则，添加州/省和选中的城市
                        state?.cityList?.forEach(city => {
                            tmpRequestBoundaryCode.push(city?.cityCode);
                        });
                    }
                } else {
                    // 如果没有城市，则只添加州/省
                    // setFinalRequestBoundaryState(prev => [...prev, `${state.stateName}`]);
                    tmpRequestBoundaryCode.push(state?.stateCode);
                }
            });

            // setFinalRequestBoundaryState(tmpRequestBoundaryState);
            dispatch(updateFinalRequestBoundaryCode(tmpRequestBoundaryCode));
        }
        else{
            dispatch(updateFinalRequestBoundaryCode([]));
        }
    },[checkedKeys]);


    const buildTreeData = (data: IGetCountriesTreeResModel[]) => {
        const treeMap = new Map<string, TreeDataNode>();

        data.forEach(item => {
            if (!item.country || !item.state) return; // 忽略缺少必要信息的项

            const countryKey = `${item.country}`;
            const stateKey = `${countryKey}#${item.state}`;

            // 创建或获取国家节点
            if (!treeMap.has(countryKey)) {
                treeMap.set(countryKey, {
                    title: item.country,
                    key: countryKey,
                    children: [],
                    // disabled: true
                });
            }

            // 获取国家节点，用于添加州/省节点
            const countryNode = treeMap.get(countryKey);

            // 查找是否已有对应的州/省节点
            let stateNode = countryNode?.children?.find(child => child.key === stateKey);

            if (!stateNode) { // 如果没有找到，则创建新的州/省节点
                stateNode = {
                    title: item.state,
                    key: stateKey,
                    children: [],
                };
                countryNode?.children?.push(stateNode);
            }

            // 如果有城市信息，则添加城市节点
            if (item.city) {
                const cityNode: TreeDataNode = {
                    title: item.city,
                    key: `${stateKey}#${item.city}`
                };
                stateNode.children?.push(cityNode);
            }
        });

        // 返回顶级国家节点列表
        // const tmpTreeData = Array.from(treeMap.values()).filter(node => node.key?.toString()?.startsWith("country-"));
        const tmpTreeData = Array.from(treeMap.values()).filter(node => node.key?.toString());
        setFinalTreeData(tmpTreeData);
        setExpandedKeys(["United States"]);
        dispatch(updateExpandedKeys(["United States"]));
    };

    const onExpand: TreeProps["onExpand"] = (expandedKeysValue) => {
        console.log("6666 onExpand", expandedKeysValue);
        console.log("66666 expandedKeysValue",typeof(expandedKeysValue));
        setExpandedKeys(expandedKeysValue);
        dispatch(updateExpandedKeys(expandedKeysValue));
        setAutoExpandParent(false);
        dispatch(updateAutoExpandParent(false));
    };

    const onCheck: TreeProps["onCheck"] = (checkedKeysValue) => {

        // if(finalRequestBoundaryCode?.length >= 3){
        //     const tmpCodes = getRequestBoundaryCode(checkedKeysValue as React.Key[]);
        //     if(tmpCodes && tmpCodes?.length > 3){
        //         dispatch(updateCommonWarnMessage("If you want to see more areas, it is recommended to switch to Draw on Map."));
        //         return;
        //     }
        // }
        console.log("onCheck", checkedKeysValue);
        setCheckedKeys(checkedKeysValue as React.Key[]);
        console.log("66666 checkedKeysValue",typeof(checkedKeysValue));
        dispatch(updateCheckedKeys(checkedKeysValue));
    };

    const onSelect: TreeProps["onSelect"] = (selectedKeysValue, info) => {
        console.log("onSelect", info);
        setSelectedKeys(selectedKeysValue);
        console.log("66666 selectedKeysValue",typeof(selectedKeysValue));
        dispatch(updateSelectedKeys(selectedKeysValue));
    };

    const publicDeleteSelectedRegion = (code: string) => {
        const tmpCheckedKeys:string[] = [];
        if(code === "USA"){
            setCheckedKeys([]);
            dispatch(updateCheckedKeys([]));
            return;
        }
        checkedKeys.forEach((item) => {
            const splitKey = item?.toString().split("#");
            const tmpCity = countriesTreeData?.find( x => x?.cityCode === code);
            if(tmpCity){
                // is city, sou just delete city
                // if(splitKey.length === 2) { // 国家#州/省格式
                //     if (splitKey[1] !== regionName) {
                //         tmpCheckedKeys.push(item.toString());
                //     }
                // }
                if(splitKey.length === 3) { // 国家#州/省#城市格式
                    if (splitKey[2] !== tmpCity?.city && splitKey[1] !== tmpCity?.state) {
                        tmpCheckedKeys.push(item.toString());
                    }
                }
            }
            else{
                const tmpState = countriesTreeData?.find(x => x?.stateCode === code);
                if(tmpState){
                    // mean is state
                    if(splitKey?.length >= 2 && splitKey[1] !== tmpState?.state){
                        tmpCheckedKeys.push(item.toString());
                    }
                }

            }

        });
        setCheckedKeys(tmpCheckedKeys);
        dispatch(updateCheckedKeys(tmpCheckedKeys));
    };

    useEffect(()=>{
        if(countriesTreeData?.length >= 1){
            buildTreeData(countriesTreeData);
        }
    },[countriesTreeData]);

    useEffect(()=>{
        // return;
        if(finalRequestBoundaryCode?.length === 1 && finalRequestBoundaryCode[0] === "USA"){
            setDisplaySelectedRegionName([{
                name: "United States",
                code: "USA"
            }]);
            return;
        }
        if(finalRequestBoundaryCode?.length >= 1){
            const tmpDisplaySelectedRegionName: IDisplayModel[] = [];
            finalRequestBoundaryCode.forEach((item) => {
                const tmpCity = countriesTreeData?.find( x => x?.cityCode === item);
                if(tmpCity){
                    // mean is city
                    tmpDisplaySelectedRegionName.push({
                        name: tmpCity?.city,
                        code: tmpCity?.cityCode
                    });
                }
                else{
                    // mean is state or country
                    const tmpState = countriesTreeData?.find(x => x?.stateCode === item);
                    if(tmpState){
                        tmpDisplaySelectedRegionName.push({
                            name: tmpState?.state,
                            code: tmpState?.stateCode
                        });
                    }
                    else{
                        tmpDisplaySelectedRegionName.push({
                            name: item,
                            code: item
                        });
                    }
                }
            });
            setDisplaySelectedRegionName(tmpDisplaySelectedRegionName);
        }
        else{
            setDisplaySelectedRegionName([]);
        }
    },[finalRequestBoundaryCode]);


    const getBoundariesFunc = async (country: string) => {
        try {
            const res = await getBoundaries(country);
            if (res) {
                localforage.setItem(country, JSON.stringify(res?.data)).then(() => {
                    // dispatch(updateIsGetBoundaryData(true));
                });
            }
        }
        catch (error) {
            console.log("error", error);
            dispatch(updateCommonWarnMessage("Boundaries are not available for the selected region: " + country));
            localforage.setItem(country, "failed");
        }
        finally {
            // setIsBoundaryFetching(false);
        }
    };
    const slefSleep = (ms: number) => {
        return new Promise(resolve => setTimeout(resolve, ms));
    };
    const blockForOneSecond = async () => {
        await slefSleep(1000); // 模拟阻塞1秒
    };

    useEffect(() => {
        if(finalRequestBoundaryCode?.length === 0) return;
        if(finalRequestBoundaryCode?.length === 1 && finalRequestBoundaryCode[0] === "USA") {
            dispatch(updateSelectedCountry(["USA"]));
            return;
        }
        const checkAndFetchData = async () => {
            if(needClearRegion) return;
            const finalDispalyNode = finalRequestBoundaryCode?.filter(x => !(["United States"]?.includes(x)));
            if (finalDispalyNode?.length > 0) {
                dispatch(updateIsLoadingForGetBoundary(true));
                let successUniqueCountryArr = [...finalDispalyNode];
                for (const country of finalDispalyNode) {
                    const item = await localforage.getItem(country);

                    if (item === "failed") {
                        // failed
                        await blockForOneSecond();
                        successUniqueCountryArr = finalDispalyNode.filter(value => value !== country);
                        if (country === finalDispalyNode?.[finalDispalyNode?.length - 1]) {
                            dispatch(updateCommonWarnMessage("Boundaries are not available for the selected region"));
                        }
                    }
                    else if (!item) {
                        await getBoundariesFunc(country);
                    } else {
                        // 如果有数据，你可以在这里直接使用它或者执行其他操作
                        await blockForOneSecond();
                    }
                }
                dispatch(updateIsLoadingForGetBoundary(false));
                dispatch(updateSelectedCountry(successUniqueCountryArr));
            }
            else {
                dispatch(updateSelectedCountry([]));
            }
        };

        // 调用异步函数
        checkAndFetchData();

    }, [finalRequestBoundaryCode]);

    console.log("lanxue tree countriesTreeData", countriesTreeData);
    console.log("lanxue tree finalTreeData", finalTreeData);
    console.log("lanxue tree data checkedKeys", checkedKeys);
    console.log("lanxue tree data selectedKeys", selectedKeys);
    console.log("lanxue tree data expandedKeys", expandedKeys);
    console.log("lanxue tree data finalRequestBoundaryState", finalRequestBoundaryState);
    console.log("lanxue tree data finalRequestBoundaryCode", finalRequestBoundaryCode);
    //open selectedFavouritesInformation
    useEffect(() => {
        if (selectedFavouritesInformation && selectedFavouritesInformation?.options &&
            selectedFavouritesInformation?.options?.currentTab === LightningTabsEnum.Region
        ) {
            console.log("66666 selectedFavouritesInformation",selectedFavouritesInformation);
            // setDisplaySelectedRegionName(selectedFavouritesInformation?.options?.finalRequestBoundaryState);
            setAutoExpandParent(selectedFavouritesInformation?.options?.autoExpandParent);
            setCheckedKeys(selectedFavouritesInformation?.options?.checkedKeys);
            setExpandedKeys(selectedFavouritesInformation?.options?.expandedKeys);
            setSelectedKeys(selectedFavouritesInformation?.options?.selectedKeys);

            dispatch(updateFinalRequestBoundaryState(selectedFavouritesInformation?.options?.finalRequestBoundaryState));
            dispatch(updateFinalRequestBoundaryCode(selectedFavouritesInformation?.options?.finalRequestBoundaryCode));

            dispatch(updateAutoExpandParent(selectedFavouritesInformation?.options?.autoExpandParent));
            dispatch(updateCheckedKeys(selectedFavouritesInformation?.options?.checkedKeys));
            dispatch(updateSelectedKeys(selectedFavouritesInformation?.options?.selectedKeys));
            dispatch(updateExpandedKeys(selectedFavouritesInformation?.options?.expandedKeys));

            dispatch(updateSelectedCountry(selectedFavouritesInformation?.options?.selectedCountry));
        }
    }, [selectedFavouritesInformation]);

    // 清除处理函数
    const handleClear = () => {
        // 1. 重置本地状态
        setCheckedKeys([]);
        setSelectedKeys([]);
        setExpandedKeys(["United States"]);
        setAutoExpandParent(true);

        // 2. 重置Redux状态（关键：确保彻底清空）
        dispatch(updateCheckedKeys([]));
        dispatch(updateSelectedKeys([]));
        dispatch(updateExpandedKeys(["United States"]));
        dispatch(updateAutoExpandParent(true));
        dispatch(updateSelectedCountry([]));
        dispatch(updateFinalRequestBoundaryState([]));
        dispatch(updateFinalRequestBoundaryCode([]));

        dispatch(updateNeedClearRegion(false)); // 重置needClear状态
    };

    // 监听needClear状态，触发清除
    useEffect(() => {
        if (needClearRegion) {
            handleClear();
        }
    }, [needClearRegion]);
    return (
        <div className="lightning-region">
            {/* show selected Region */}
            <div className="lightning-region-title-container">
                <div className="lightning-region-title">
                    Administrative Areas
                </div>
                <div className="lightning-region-selected-container"
                >
                    {
                        displaySelectedRegionName?.length >= 1 ? (
                            displaySelectedRegionName.map((item, index) => {
                                return(
                                    <>
                                        <div className="lightning-region-selected-item">
                                            <span>{item?.name}</span>
                                            <span className="lightning-region-selected-item-icon"
                                                onClick={()=>{
                                                    publicDeleteSelectedRegion(item?.code);
                                                }}
                                            >
                                                <img src={closeIcon}></img>
                                            </span>
                                        </div>

                                    </>
                                );
                            })
                        ) : (
                            <span style={{color: "rgba(0, 0, 0, 0.25)"}}></span>
                        )
                    }
                </div>
            </div>
            {/* show Tree Data */}
            <div className="lightning-region-content">
                {/* Region content will be rendered here */}
                <Spin spinning={finalTreeData?.length === 0} tip="Loading...">
                    <Tree
                        checkable
                        onExpand={onExpand}
                        expandedKeys={expandedKeys}
                        autoExpandParent={autoExpandParent}
                        onCheck={onCheck}
                        checkedKeys={checkedKeys}
                        onSelect={onSelect}
                        selectedKeys={selectedKeys}
                        // treeData={treeData}
                        treeData={finalTreeData}
                    />
                </Spin>

            </div>

            {/* show button */}
            <div className="lightning-region-button">
                <LightingInvokeButton />
            </div>
        </div>
    );
};

export default LightningRegion;